import { transparentize } from 'polished';
import styled, { css } from 'styled-components';

import {
    MAX_CONTENT_HEIGHT,
    MAX_OVERSIZED_CONTENT_HEIGHT,
} from './ShowMoreWrapper';

import IconExternal from '@assets/images/externalIcon.svg';

export const ShowMoreWrapperElement = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const MoreTextWrapper = styled.div`
    align-items: center;
    cursor: pointer;
    display: flex;
    justify-content: center;
    width: 100%;
`;

const msTeamsCss = css`
    a:after {
        content: url(${IconExternal});
        left: 6px;
        margin-right: 6px;
        position: relative;
        top: 3px;
    }
`;

const bottomGradientCss = css(
    ({ theme: { palette } }) => css`
        &:after {
            background: linear-gradient(
                to bottom,
                ${transparentize(1, palette.tertiary.background)},
                ${transparentize(0, palette.tertiary.background)}
            );
            bottom: 0;
            content: '';
            height: 100px;
            left: 0;
            position: absolute;
            right: 0;
        }
    `,
);

export const TextContent = styled.div<{
    isMsTeams?: boolean;
    isOversized?: boolean;
    showMoreContent?: boolean;
}>(
    ({ isMsTeams, isOversized, showMoreContent }) => css`
        max-height: ${MAX_CONTENT_HEIGHT}px;
        overflow: hidden;
        position: relative;

        ${isMsTeams && msTeamsCss}
        ${isOversized &&
        css`
            height: ${MAX_OVERSIZED_CONTENT_HEIGHT}px;
            max-height: unset;

            ${!showMoreContent && bottomGradientCss}
            ${showMoreContent && 'height: auto;'}
        `}
    `,
);
